import { NewCard } from "@components/Cards/Templates/newCard";
import CreateTenantLicenseTable from "@components/Tables/CreateTenantLicenseTable";
import { CONTRACT } from "@types/contract";
import { APP } from "@types/app";

interface ContractStatusCardProps {
  contractData: CONTRACT;
  setContractData?: (data: CONTRACT) => void;
  updateContractData?: (
    app_id: number,
    key: keyof CONTRACT,
    value: any,
  ) => void;
  appData: APP;
  loading: boolean;
}

export const ContractStatusCard: React.FC<ContractStatusCardProps> = ({
  contractData,
  setContractData,
  updateContractData,
  appData,
  loading,
}: any) => {
  return (
    <NewCard
      header="契約状態"
      bodyLabel=""
      isTable
      loading={loading}
      bodyContents={
        <div className="mayo-card-body">
          <CreateTenantLicenseTable
            contractData={contractData}
            setContractData={setContractData}
            updateContractData={updateContractData}
            appData={appData}
          />
        </div>
      }
    />
  );
};
